import moment from 'moment';

import { ia } from 'lib/helpers/utility';

export const formattedValue = ({ value, format, isRange }) => {
  // Use local formatting without timezone conversion to preserve the exact time
  // Create moment objects without timezone conversion to prevent date shifting
  const createLocalMoment = (date) => {
    // Create moment from the date components to avoid timezone conversion
    const d = new Date(date);
    return moment({
      year: d.getFullYear(),
      month: d.getMonth(),
      date: d.getDate(),
      hour: d.getHours(),
      minute: d.getMinutes(),
      second: d.getSeconds()
    });
  };

  return isRange
    ? ia(value) && value[0] && value[1]
      ? createLocalMoment(value[0]).isSame(createLocalMoment(value[1]), 'day')
        ? `${createLocalMoment(value[0]).format('MM/DD/YYYY, hh:mm A')} - ${createLocalMoment(value[1]).format('hh:mm A')}`
        : value.map((d) => createLocalMoment(d).format(format)).join(' - ')
      : ''
    : value
      ? createLocalMoment(value).format(format)
      : '';
};
